import React from 'react';
import FloorPlansViewer from '../components/FloorPlansViewer';
import FacadeSection from '../components/FacadeSection';
import NavigatorWizard from '../components/navigator/NavigatorWizard';
import LoadingSpinner from '../components/LoadingSpinner';
import { usePageLayouts } from '../lib/hooks/usePageLayouts';

const FloorNavigatorPage = () => {
  const { layouts, loading } = usePageLayouts();

  // Wait for the stored layout so the page doesn't flash the classic view
  // before switching to the configured one.
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (layouts.navigator === 'wizard') {
    return <NavigatorWizard />;
  }

  return (
    <div className="min-h-screen bg-neutral-50">
      <div className="pt-24">
        <FacadeSection />
        <div className="container-custom">
          <FloorPlansViewer />
        </div>
      </div>
    </div>
  );
};

export default FloorNavigatorPage;
